import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import StyledElements from './styles';
function InfoBand({ band }) {
    const { description, subDescription, note, priceLabel = 'FREE', } = band;
    return (_jsxs(StyledElements.Item, { children: [_jsxs(StyledElements.Content, { children: [_jsx(StyledElements.Name, { children: description }), (subDescription || note) && (_jsxs(StyledElements.Note, { children: [subDescription && _jsx("p", { children: subDescription }), note && (_jsxs("p", { children: [_jsx(StyledElements.NoteLabel, { children: "Note: " }), note] }))] }))] }), _jsx(StyledElements.Price, { children: priceLabel })] }));
}
export default InfoBand;
